import React, { createContext, useContext, useState } from 'react';

type SidebarMobileContextType = {
    sidebarOpen: boolean;
    setSidebarOpen: (open: boolean) => void;
};

const SidebarMobileContext = createContext<SidebarMobileContextType | undefined>(undefined);

export const SidebarMobileProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [sidebarOpen, setSidebarOpen] = useState(false);

    return (
        <SidebarMobileContext.Provider value={{ sidebarOpen, setSidebarOpen }}>
            {children}
        </SidebarMobileContext.Provider>
    );
};

export const useSidebarMobile = () => {
    const ctx = useContext(SidebarMobileContext);
    if (!ctx) throw new Error('useSidebarMobile must be used within SidebarMobileProvider');
    return ctx;
};
